import React from "react";
var __jsx = React.createElement;
import Markdown from "markdown-to-jsx";
export default function BadgePill(_ref) {
  var badge = _ref.badge;
  var titles = badge.titles,
    bg_color = badge.bg_color;
  return /*#__PURE__*/React.createElement("span", {
    className: "flex shrink-0 items-center gap-0.5 rounded-sm px-1.5 py-1.5 text-[10px] font-semibold leading-none",
    style: {
      backgroundColor: bg_color
    }
  }, titles.map(function (title, idx) {
    var _title$text;
    return /*#__PURE__*/React.createElement(Markdown, {
      key: idx,
      options: {
        forceInline: true
      },
      className: "[&_strong]:font-bold",
      style: {
        color: title === null || title === void 0 ? void 0 : title.text_color
      }
    }, (_title$text = title === null || title === void 0 ? void 0 : title.text) !== null && _title$text !== void 0 ? _title$text : "");
  }));
}